import React from 'react'
import styled, { css, keyframes } from 'styled-components'
import { breakpoint } from './styles'

const SearchButton = ({ searchOpen, setSearchOpen, mobileOnly }: any) => {
  return (
    <SearchButtonContainer mobileOnly={mobileOnly} style={{ marginRight: 0 }} onClick={(e: any) => { e.stopPropagation(); setSearchOpen(!searchOpen); e.preventDefault() }}>
      <img src="/images/search.svg" alt="Search" width="24" height="24" />
    </SearchButtonContainer>
  )
}

export default SearchButton

const rotate = keyframes`
  from {
    transform: translateX(-50%);
    width: 50%;
  }

  to {
    transform: translateX(0);
    width: 100%;
  }
`

const MenuItemBase = styled.div<any>`
  font-weight: 700;
  font-size: 1.125rem;
  margin: 0;
  background-color: rgba(0,0,0,0);
  color: var(--nav-text, var(--text));
`

const MenuItem = styled(MenuItemBase)`
  position: relative;
  padding: 1rem 1.5rem;
  border-bottom: 1px #666 solid;
  color: var(--text);
  @media ${breakpoint.desktop} {
    margin: 0 27px;
    padding: 0;
    border-bottom: 0;
    &:hover:after {
      content: "";
      background: var(--text);
      width: 100%;
      height: 2.5px;
      position: absolute;
      bottom: -8px;
      left: 0;
      transition: all 250ms ease;
      transform: translateX(0);
      animation: ${rotate} 250ms ease 1;
    }
  }

  ${props => props.selected && css`
    @media ${breakpoint.desktop} {
      &:after {
        content: "";
        background: var(--text);
        width: 100%;
        height: 2.5px;
        position: absolute;
        bottom: -8px;
        left: 0px;
        transition: all 250ms ease;
        transform: translateX(0);
        animation: ${rotate} 250ms ease 1;
      }
    }
  `}

  img {
    position: relative;
    top: 7px;
  }

  a {
    color: var(--nav-text, var(--text));
  }
  
  ${props => props.selected && css`
    background-color: var(--nav-bg-selected);
    a {
      color: var(--nav-text-selected);
    }
  `}
`

export const SearchButtonContainer = styled(MenuItem)<any>`
  ${props => props.mobileOnly && css`
    img {
      filter: invert(1);
      top: 0;
    }
    @media ${breakpoint.desktop} {
      display: none;
    }
  `}
  border-bottom: 0;
  padding: 0;
  margin: 0 0 0 2rem;
  cursor: pointer;
  @media ${breakpoint.desktop} {
    margin: 0;
  }
`